module.exports = __webpack_public_path__ + "static/img/step4.ba11131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step4.png
// module id = QncL
// module chunks = 1